import type { FC } from "react";
import {
    FixErrorsIcon,
    RetroIcon,
    ShortenIcon,
    SimplifyIcon,
    SummaryIcon,
} from "@/icons/ai-actions";
import type { CreateSubMenuActions, EditSubMenuActions } from "../types";

type CreateItem = {
    title: string;
    action: CreateSubMenuActions;
    icon: FC;
};

type EditItem = {
    title: string;
    action: EditSubMenuActions;
    icon: FC;
};

export const CREATE_AI_ACTIONS: CreateItem[] = [
    {
        title: "Итоги ретро",
        action: "retro_summary",
        icon: RetroIcon,
    },
    {
        title: "Краткое содержание",
        action: "short_summary",
        icon: SummaryIcon,
    },
];

export const EDIT_AI_ACTIONS: EditItem[] = [
    {
        title: "Исправить ошибки",
        action: "fix_errors",
        icon: FixErrorsIcon,
    },
    {
        title: "Сократить",
        action: "shorten",
        icon: ShortenIcon,
    },
    {
        title: "Упростить",
        action: "simplify",
        icon: SimplifyIcon,
    },
];
